export default __webpack_public_path__ + "static/phoneMobile3-4a63885481841df5069ec7f8bb3f9f0a.png";